import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useLanguage } from '../../context';
import { getLocalizedPath } from '../../helpers/routes';

const Breadcrumbs = () => {
  const location = useLocation();
  const intl = useIntl();
  const { language } = useLanguage();
  const pathname = location.pathname;

  // Don't show on home page
  if (pathname === '/' || pathname === '/fr/' || pathname === '/fr') return null;

  // Split path into segments and filter out empty ones, language prefix, and 'info' structural segment
  const pathnames = pathname.split('/').filter((x) => x && x !== 'fr' && x !== 'info');

  return (
    <nav className="bg-white border-b border-slate-100 py-3 mb-0">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12">
        <ol className="flex items-center space-x-2 text-sm text-slate-500 overflow-x-auto whitespace-nowrap scrollbar-hide">
          <li className="flex items-center">
            <Link
              to={getLocalizedPath('/', language)}
              className="flex items-center hover:text-[#16A34A] transition-colors duration-200"
            >
              <Home size={16} className="mr-1" />
              <span className="font-medium">
                {intl.formatMessage({ id: 'nav.home', defaultMessage: 'Accueil' })}
              </span>
            </Link>
          </li>

          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            
            // Format the name (capitalize, replace hyphens, etc.)
            const displayName = name
              .split('-')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');

            return (
              <li key={name} className="flex items-center">
                <ChevronRight size={14} className="mx-1 text-slate-400" />
                {isLast ? (
                  <span className="font-semibold text-[#0a1628] truncate max-w-[200px]">
                    {displayName}
                  </span>
                ) : (
                  <Link
                    to={getLocalizedPath(routeTo, language)}
                    className="hover:text-[#16A34A] transition-colors duration-200"
                  >
                    {displayName}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
